export const INVENTORY_METRICS_API_BASE_URL = `${import.meta.env.BUILD_API_BASE_URL}/math/v1/math/inventory`;
